import { render, staticRenderFns } from "./BaseAccountSwitcher.vue?vue&type=template&id=65641d79&"
import script from "./BaseAccountSwitcher.vue?vue&type=script&lang=js&"
export * from "./BaseAccountSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./BaseAccountSwitcher.vue?vue&type=style&index=0&id=65641d79&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports